var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49 31.63c0 1.986.816 3.151 2.452 3.5H.043c.612-.176 1.417-1.314 2.41-3.413L2.408 3.629C2.409 1.644 1.605.48 0 .13h9.899c-.612.177-1.417 1.315-2.41 3.414v28.088Zm15.725-3.483c-1.754 3.162-4.234 5.489-7.447 6.983 4.469-.353 8.235-2.146 11.303-5.379 3.069-3.233 4.673-7.093 4.818-11.574.146-4.684-1.33-8.769-4.425-12.252C24.368 2.44 20.484.51 15.81.13c3.386 1.608 5.972 4.084 7.753 7.423 1.605 3.135 2.35 6.673 2.232 10.628-.117 3.778-.976 7.102-2.585 9.97l.004-.004Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.172 31.626c0 1.986.816 3.155 2.452 3.504h-9.899c.612-.177 1.417-1.314 2.41-3.417L36.09 3.59c0-1.985-.804-3.155-2.409-3.504h9.899c-.612.177-1.417 1.315-2.41 3.417v28.123Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.93 35.57c-4.206-.381-7.682-2.311-10.424-5.791-2.57-3.276-3.916-7.09-4.03-11.449-.117-4.531 1.11-8.565 3.68-12.104C52.904 2.484 56.478.408 60.888 0c-5.81 3.1-8.584 9.18-8.321 18.244.262 8.741 3.052 14.516 8.368 17.326h-.004ZM67.722 0c4.206.38 7.682 2.31 10.424 5.79 2.57 3.277 3.912 7.079 4.03 11.406.117 4.532-1.127 8.569-3.724 12.104-2.746 3.77-6.324 5.862-10.73 6.274 5.693-3.014 8.412-9.02 8.149-18.025-.236-8.945-2.95-14.795-8.15-17.545V0Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.496 37.461 89.36 7.769v23.47c-.087.933.102 1.753.569 2.452.466.702 1.153 1.122 2.06 1.27H84.89c1.605-.262 2.409-1.502 2.409-3.723V4.034c0-.585-.102-1.181-.306-1.797C86.586 1.009 85.868.369 84.848.31h9.679c-.816.236-1.228.761-1.228 1.578 0 .38.086.772.262 1.18l17.872 22.297V3.987c0-1.958-.875-3.182-2.629-3.68h7.054c-1.577.29-2.366 1.518-2.366 3.68v33.47l.004.004Z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.368 2.28c4.583 2.919 6.878 7.972 6.878 15.156v13.841c.495 2.57 1.33 3.857 2.495 3.857h-10.644c1.781-.322 2.672-1.534 2.672-3.637V17.216c0-3.154-.278-5.928-.832-8.322-1.287-5.606-3.766-8.54-7.446-8.804 2.656.236 4.951.965 6.877 2.19Zm13.885 1.27c0 3.36-2.087 7.989-6.265 13.886L147.661.306h-9.679c.848.612 1.271 1.695 1.271 3.24v.005Z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.696 14.86h.006c.186 1.497.279 3.01.162 4.51-.054.752-.16 1.5-.335 2.232-.09.367-.187.732-.303 1.081a5.606 5.606 0 0 1-.49.986c-.136.224-.282.444-.43.666-.062.094-.125.188-.187.284l-.002.002c-.109.175-.18.269-.3.333l-.002.002a.823.823 0 0 1-.425.085c-.213-.013-.444-.05-.682-.087a14.186 14.186 0 0 0-.418-.062l-1.13-.168-2.26-.334-1.134-.157-.565-.078h-.002a2.2 2.2 0 0 1-.243-.045l-.02-.005c.061-.518.134-1.038.207-1.562.146-1.045.293-2.1.352-3.168.122-1.713-.055-3.44-.339-5.103-.05-.3-.102-.6-.154-.9a56.277 56.277 0 0 1-.261-1.577.466.466 0 0 1 .002-.13l.008-.004a.483.483 0 0 1 .095-.029c.12-.023.256-.042.395-.062l.212-.031 1.252-.184 2.499-.37 1.25-.183a6.034 6.034 0 0 0 .315-.046c.104-.015.203-.029.3-.032l.125-.008.03-.002c.05-.003.098-.006.145-.006.091.004.184.022.272.047l.013.004h.004c.35.096.594.402.837.729.238.319.434.669.592 1.035.325.738.496 1.532.61 2.336Zm-9.023 7.524c-.07.536-.141 1.072-.203 1.612l-.091-.02.08.112-.03.285v.138h.113l.026.005c.079.022.16.041.24.058l.066.092.008-.077c.227.044.456.072.678.1l.144.017 1.13.145 2.264.294c.273.033.546.07.82.107.48.065.963.13 1.452.172h.008c.201 0 .42-.032.61-.141.202-.109.328-.303.421-.463l.132-.206c.16-.252.322-.505.474-.765a5.74 5.74 0 0 0 .498-1.05v-.002c.12-.369.207-.742.293-1.114v-.001c.163-.747.265-1.51.317-2.275.106-1.527 0-3.064-.201-4.575l-.027-.2-.005.005c-.11-.747-.276-1.498-.58-2.2a5.526 5.526 0 0 0-.611-1.091v-.001c-.232-.311-.512-.687-.948-.822a.135.135 0 0 0-.042-.016 1.53 1.53 0 0 0-.331-.057h-.008c-.065 0-.136.004-.204.008-.041.003-.081.006-.117.007-.147.005-.296.026-.439.046-.067.009-.133.018-.196.025h-.002l-1.251.161-2.507.326-1.252.16-.002.001c-.09.014-.18.025-.27.036l-.04.005a8.129 8.129 0 0 0-.32.046h-.002c-.1.02-.262.055-.354.191l-.002.004c-.082.132-.074.277-.066.382v.005c.069.519.15 1.038.23 1.555.049.316.097.632.143.946.251 1.658.426 3.335.29 5.003v.001c-.071 1.015-.203 2.018-.336 3.026Zm7.035-11.822.006.002-.001.003h-.002l-.006.02-.001.002v-.015l.002-.012h.002Zm-6.962 1.094a.048.048 0 0 1-.005.008l.005-.008Z",
    fill: "url(#f)",
    stroke: "url(#g)",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.904 26.711c.255-.07.51-.106.761-.16l.765-.11c.255-.044.51-.048.769-.075l.769-.059.443-.035-.192.416v.011l-.07.142h-.157l-.758.02c-.25 0-.506.019-.757 0l-.761-.032c-.255-.028-.506-.04-.761-.082v-.028l3.025-.169-.024.016v-.008l.032.043-3.076.142v-.028l-.008-.004Z",
    fill: "url(#h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m66.91 26.487-2.507.138-2.508.094-1.251.039c-.416-.02-.64.114-.86.451-.246.357-.553.714-.976.942-.42.235-.922.286-1.373.22l.082-.514c.377.058.745.027 1.067-.13.322-.157.596-.44.828-.761.122-.169.282-.38.518-.514.231-.137.522-.16.73-.153h1.259l2.519.035c.84.008 1.68.04 2.519.07h-.008l1.212-.074v.028l-1.204.133-5.038.055-1.26.012c-.207-.004-.42.02-.596.122-.18.102-.31.266-.427.439-.244.341-.538.663-.922.86-.381.2-.828.23-1.244.156l.008-.055c.408.063.835.02 1.2-.18.365-.197.652-.51.89-.852.119-.172.264-.341.456-.44.192-.105.416-.117.62-.113l1.255-.012 5.014-.039v.028l-.003.015Z",
    fill: "url(#i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m58.368 10.338-.816.267c-.294.094-.604.165-.874.24-.283.074-.562.152-.848.207l-.855.18-.29.064-.009-.31c-.007-.287-.015-.573 0-.856l.012-.266.247.007c.57.02 1.138.008 1.707.055l.855.06.856.097h.05l-.007.047v.008l-.02.208-.008-.008Zm-.023-.02-.02-.188v-.008l.016.016-3.413.012.027-.027v.855l-.031-.028 3.42-.631Z",
    fill: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.47 25.51v.208h-.039c-.294.043-.588.07-.883.106l-.882.058c-.589.047-1.173.036-1.762.055l-.247.008-.012-.267a12.395 12.395 0 0 1 0-.851l.008-.31.29.059.047.008.212.043v.208h-.004l-.204-.247c.506.113 1.02.204 1.523.345l.757.2c.25.063.502.15.753.224h-.008c.169.043.314.106.444.149l.007.004Zm-.023.015-.428-.078-3.068-.58h-.023v-.028l.023.027-.047-.008.031-.027v.851l-.027-.027 3.523.012-.015.011.03-.153Z",
    fill: "url(#k)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m72.422 21.489.036-.205-.202.152-.074.056a26.3 26.3 0 0 1-.786.578l-.95.674a21.554 21.554 0 0 0-.988.737h-.001l-.973.77-.88.698.084.176 1.103-.239.09-.02.003-.002v.002a4.212 4.212 0 0 0 1.076-.46l.001-.001a7.406 7.406 0 0 0 .793-.55v-.001l.002-.001c.243-.204.47-.427.684-.66l.001-.002c.209-.232.418-.477.584-.757.005-.007.01-.014.013-.021.151-.254.306-.514.37-.847l.034-.067-.02-.01Zm-2.685 2.506-.006.003c-.145.077-.29.15-.438.213l2.681-2.265a3.285 3.285 0 0 1-.207.301l-.001.001c-.181.239-.382.458-.598.667-.43.419-.91.786-1.431 1.08Z",
    stroke: "url(#l)",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m71.52 13.553-.096-.075c-.283-.22-.591-.458-.903-.676h-.002c-.32-.235-.656-.47-1.005-.709l.056-.083c-.27-.18-.544-.387-.816-.595l-.235-.178 3 2.316Zm0 0 .054-.11.004-.007.02-.04-.017-.043c-.069-.167-.15-.3-.23-.428a5.68 5.68 0 0 1-.093-.156 6.707 6.707 0 0 0-.35-.55l-.003-.003a10.075 10.075 0 0 0-.852-.994l1.467 2.331Zm-.895-1.108c.084.094.163.194.24.298L68.2 10.51l.019.006c.186.076.368.167.542.273.355.212.683.47.993.75l.001.001c.313.274.591.587.87.905Z",
    stroke: "url(#m)",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.995 26.573c.102.322.06.593-.02.852-.093.255-.219.498-.493.694l-.028-.008.243-.777.271-.769.027.008Z",
    fill: "url(#n)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.775 8.851c.263-.043.522-.055.785-.082l.78-.031c.263-.016.522.003.781.003l.78.02-.25.38v-.007l.22.145-.766-.063c-.255-.023-.51-.031-.765-.074l-.76-.11c-.256-.055-.507-.09-.762-.161v-.028l3.068.142h.02l.008.015v.008l.023.043h-.047l-3.115-.176v-.028.004Z",
    fill: "url(#o)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m68.084 26.476.016.091.097-.016a6.398 6.398 0 0 0 2.073-.73A7.99 7.99 0 0 0 72 24.484m-3.915 1.992 4.805-14.28c-.828-1.177-1.91-2.264-3.295-2.825a6.582 6.582 0 0 0-2.15-.483 40.063 40.063 0 0 0-1.348-.013c-.264 0-.53 0-.799-.003l-4.26-.007h-.534a.902.902 0 0 1-.435-.079.925.925 0 0 1-.334-.29m8.35 17.98h-.002l-.018-.093-.008-.04-.02-.1.007-.001m.04.235-.04-.235m3.956-1.758-.07-.07.07.07Zm0 0c.514-.51.988-1.083 1.346-1.733m0 0-.087-.049.087.05Zm0 0a5.482 5.482 0 0 0 .683-2.113 6.08 6.08 0 0 0 .024-1.107 31.572 31.572 0 0 1-.03-1.055c-.013-.704.003-1.409.03-2.114.004-.112.01-.226.016-.341.012-.241.025-.49.02-.744a5.338 5.338 0 0 0-.14-1.123 4.89 4.89 0 0 0-.389-1.07 7.05 7.05 0 0 0-.535-.869l-.052-.076c-.835-1.186-1.931-2.29-3.34-2.86a6.681 6.681 0 0 0-2.183-.49h-.002c-.465-.016-.91-.015-1.353-.014-.265 0-.529 0-.795-.003h-.001l-4.261-.007H60.5a.804.804 0 0 1-.389-.068l-.002-.001a.828.828 0 0 1-.296-.26l-.08.06m0 0-.064-.087a4.295 4.295 0 0 0-.27-.34c-.247-.28-.549-.538-.917-.676m1.251 1.103.08-.06-.062-.083A4.436 4.436 0 0 0 59.475 8m-.992-.608.037-.093h-.002m-.035.093a2.127 2.127 0 0 0-1.04-.115v-.003l-.098.016.006.038-.008.001-.09.016m1.23.047.034-.093h.002m0 0c.389.145.703.417.956.701m-.956-.701c-.386-.153-.805-.168-1.19-.107l-.1.015.017.1.006.038M59.475 8l-.074.067.074-.066Zm-2.223-.655-.007.001.017.098.008.047.016.097.007-.001m-.04-.242.016.098.008.047.016.097m0 0 .008.05.017.1.1-.019c.38-.068.764-.04 1.093.132.333.17.612.462.847.796m-2.065-1.06.09-.012.008-.002.009.048.054-.01c.379-.058.766-.025 1.103.151.051.026.102.055.15.087.17.115.322.259.457.417l.002.003a2.345 2.345 0 0 1 .197.254l.058.08-.063.044m0 0c.129.185.305.394.554.518m-.554-.518.063-.044.061.082a1.252 1.252 0 0 0 .472.399l-.043.081h.001m0 0c.245.13.533.13.732.13h1.303m-2.035-.13h.001l.041-.081c.08.036.162.06.245.077.158.033.32.033.453.033h.962l.333.004v.096m0 0 5.174.016m-5.174-.016 5.174.016m0 0c.84.008 1.681.166 2.448.502.447.191.868.439 1.259.729.678.52 1.263 1.17 1.76 1.87.413.569.765 1.175.918 1.85v.002c.08.334.123.68.135 1.027l-6.52-5.98Zm.922 16.932-.017-.096.101-.015c1.075-.162 2.086-.648 2.933-1.34m-3.017 1.45 3.017-1.45m0 0c.845-.705 1.61-1.53 2.093-2.513l.055-.117-2.148 2.63Z",
    fill: "url(#p)",
    stroke: "url(#q)",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.874 9.028c-.274-.2-.404-.447-.494-.706-.078-.263-.122-.538-.024-.863l.028-.008.275.777.243.788-.028.008v.004Z",
    fill: "url(#r)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m61.837 52.667-.04.016 1.139 1.812h-1.401l-1.048-1.671h-.525v1.671h-1.177v-5.08h2.338a1.71 1.71 0 0 1 1.707 1.706c0 .683-.404 1.275-.989 1.55l-.004-.004Zm-.188-1.55a.53.53 0 0 0-.526-.525h-1.161v1.047h1.161a.524.524 0 0 0 .526-.518v-.004Z",
    fill: "url(#s)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.426 49.407h3.253v1.177H65.61v.784h1.762v1.177H65.61v.773h2.036v1.185h-3.22v-5.1.004Z",
    fill: "url(#t)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.164 49.407h1.184V54.5h-.965l-1.946-2.794V54.5h-1.185v-5.093h.981l1.927 2.778v-2.778h.004Z",
    fill: "url(#u)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.56 49.415h3.971v1.177h-1.409v3.903h-1.177v-3.903h-1.384v-1.177Z",
    fill: "url(#v)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m82.097 49.407 1.954 5.093h-1.267l-.397-1.048h-2.06l-.396 1.048h-1.267l1.962-5.093H82.1h-.004Zm-.165 2.868-.576-1.49-.57 1.49h1.146Z",
    fill: "url(#w)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.555 53.31h2.322v1.185H85.37v-5.092h1.184v3.907Z",
    fill: "url(#x)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 60,
    rx: 40,
    ry: 1,
    fill: "#DEBE83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 67.667,
    y1: 23.273,
    x2: 72.316,
    y2: 23.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 85.37,
    y1: 51.953,
    x2: 88.881,
    y2: 51.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 33.682,
    y1: 17.612,
    x2: 43.628,
    y2: 17.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 46.465,
    y1: 17.785,
    x2: 82.183,
    y2: 17.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 84.848,
    y1: 18.884,
    x2: 115.862,
    y2: 18.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 118.491,
    y1: 17.612,
    x2: 147.665,
    y2: 17.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 55.32,
    y1: 17.937,
    x2: 65.195,
    y2: 17.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 55.32,
    y1: 17.937,
    x2: 65.195,
    y2: 17.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 54.896,
    y1: 26.57,
    x2: 58.223,
    y2: 26.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 57.446,
    y1: 27.35,
    x2: 68.177,
    y2: 27.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 54.782,
    y1: 10.578,
    x2: 58.514,
    y2: 10.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 54.759,
    y1: 25.239,
    x2: 58.627,
    y2: 25.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.004,
    y1: 17.632,
    x2: 31.897,
    y2: 17.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 66.671,
    y1: 11.591,
    x2: 71.489,
    y2: 11.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 57.329,
    y1: 27.342,
    x2: 58.121,
    y2: 27.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 54.767,
    y1: 9.004,
    x2: 58.133,
    y2: 9.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 57.345,
    y1: 16.86,
    x2: 73.988,
    y2: 16.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 57.345,
    y1: 16.86,
    x2: 73.988,
    y2: 16.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 57.231,
    y1: 8.24,
    x2: 58.027,
    y2: 8.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 58.781,
    y1: 51.957,
    x2: 62.936,
    y2: 51.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 64.426,
    y1: 51.957,
    x2: 67.679,
    y2: 51.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 69.256,
    y1: 51.953,
    x2: 73.349,
    y2: 51.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 74.561,
    y1: 51.957,
    x2: 78.531,
    y2: 51.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 78.664,
    y1: 51.953,
    x2: 84.051,
    y2: 51.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79A46"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 34.99,
    y: 58.99,
    width: 83.74,
    height: 5.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.86,
    dy: 1.86
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.935
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_998_5519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_998_5519",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-Logo.8bf061da741040435d7b56633306cc3b.svg";
export { ForwardRef as ReactComponent };